// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0982d35","239":"9dbfeacd","455":"39c60ab6"}[chunkId] + ".chunk.js";
};